import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchMe, loginUser, registerUser, logoutUser, setAuthUserId } from "@/lib/apiClient";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const applyUser = useCallback((u) => {
    setUser(u);
    setAuthUserId(u?.user_id || null);
  }, []);

  const refresh = useCallback(async () => {
    try {
      const u = await fetchMe();
      applyUser(u);
      return u;
    } catch {
      applyUser(null);
      return null;
    }
  }, [applyUser]);

  useEffect(() => {
    // Capture referral code from the URL (?ref=CODE) for later signup.
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) localStorage.setItem("pv_ref", ref);
    // If returning from Google OAuth, let AuthCallback handle it first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const login = async (email, password) => {
    const u = await loginUser({ email, password });
    applyUser(u);
    return u;
  };
  const register = async (email, password, name) => {
    const ref = localStorage.getItem("pv_ref") || undefined;
    const u = await registerUser({ email, password, name, ref });
    localStorage.removeItem("pv_ref");
    applyUser(u);
    return u;
  };
  const logout = async () => {
    try { await logoutUser(); } catch (err) { console.error("Logout request failed:", err); }
    applyUser(null);
  };

  const isPremium = !!user?.premium;

  return (
    <AuthContext.Provider value={{ user, loading, isPremium, login, register, logout, refresh, applyUser }}>
      {children}
    </AuthContext.Provider>
  );
}
